import { useTheme } from '@mui/material';

import { ATSConnectHiringRequestCreateFeedbackTestIds } from 'data-testids/ATS';
import { CTAButtonsContainer, Right } from './styles';
import { CTAButtonsProps, ScorecardToSubmit } from './types';
import { GreySecondaryButton } from 'sharedComponents/Buttons/GreySecondaryButton';
import { PrimaryButton } from 'sharedComponents/Buttons';
import {
  primaryButtonOverrideSx,
  secondaryButtonOverrideSx,
} from 'sharedComponents/Buttons/styles';
import { useFormContext } from 'react-hook-form';

export const CTAButtons: React.FC<CTAButtonsProps> = ({
  hasSelectedScorecard,
  isLoading,
  onCancel,
  onSaveAsDraft,
  onSaveAsCompleted,
}) => {
  const {
    handleSubmit,
    formState: { errors, isValid },
    setValue,
  } = useFormContext<ScorecardToSubmit>();

  const theme = useTheme();
  const submitShouldBeDisabled =
    !hasSelectedScorecard || Object.keys(errors).length > 0 || isLoading || !isValid;

  return (
    <CTAButtonsContainer>
      <GreySecondaryButton
        dataTestId={ATSConnectHiringRequestCreateFeedbackTestIds.CANCEL_BUTTON}
        onClick={onCancel}
        sx={{
          width: !hasSelectedScorecard ? '50%' : '25%',
          marginRight: !hasSelectedScorecard ? theme.spacing(1) : 'inherit',
        }}
      >
        Cancel
      </GreySecondaryButton>
      <Right>
        {hasSelectedScorecard && (
          <GreySecondaryButton
            dataTestId={ATSConnectHiringRequestCreateFeedbackTestIds.SAVE_AS_DRAFT_BUTTON}
            onClick={async () => {
              setValue('scorecard_complete', false);
              await handleSubmit(onSaveAsDraft)();
            }}
            sx={{ ...secondaryButtonOverrideSx(theme), marginRight: theme.spacing(1) }}
          >
            Save as draft
          </GreySecondaryButton>
        )}
        <PrimaryButton
          dataTestId={ATSConnectHiringRequestCreateFeedbackTestIds.SUBMIT_BUTTON}
          sx={{
            ...primaryButtonOverrideSx(theme),
            width: !hasSelectedScorecard ? '100%' : 'inherit',
          }}
          type="submit"
          disabled={submitShouldBeDisabled}
          onClick={handleSubmit(onSaveAsCompleted)}
        >
          Submit
        </PrimaryButton>
      </Right>
    </CTAButtonsContainer>
  );
};
